import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { placesEnvironment } from '../places-environment';
import { placesPlaceSetSchema } from '../schemas/places-place-set.schema';

/**
 * Get all place sets in the company
 * @returns An array of place sets
 */
export function getPlacesSets(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(placesEnvironment.resolve(this).placeSetsUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(z.array(placesPlaceSetSchema)));
}
